import { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'

import { useRouter } from '@/hooks/useRouter'

interface Props {
  children: (unknown) => ReactNode
}

export const PageTransition = ({ children }: Props): ReactElement => {
  const router = useRouter()
  const shouldDisableTransform = (pathname: string) =>
    pathname === '/projects/[id]'

  const currentRoute =
    router?.components && router?.pathname
      ? router.components[router.pathname]
      : null
  const hasComponent = Boolean(currentRoute?.Component)

  return (
    <Page
      data-disable-transform={
        shouldDisableTransform(router.pathname) ? 'true' : 'false'
      }
      key={router.asPath || router.pathname}
    >
      {children(
        hasComponent
          ? {
              Component: currentRoute.Component,
              pageProps: currentRoute.props?.pageProps
            }
          : {}
      )}
    </Page>
  )
}

const Page = styled.div`
  min-width: 100%;
  width: 100vw;
  opacity: 1;
  transform: translateX(0);
  transition: opacity 220ms ease, transform 220ms ease;

  &[data-disable-transform='true'] {
    transform: none !important;
  }
`
